module.exports = __webpack_public_path__ + "img/Shape_hd.6f1bcd83.png";